import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Overlay.scss'


const Overlay = ({ children, className, dataToggleOff, onClick }) => (
  <div className={cx(s.overlay, className)} data-s-toggle-off={dataToggleOff} onClick={onClick}>
    {children}
  </div>
)

Overlay.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataToggleOff: PropTypes.string,
  onClick: PropTypes.func,
}


export default Overlay
